module.exports = __webpack_public_path__ + "media/assets/login/icon-signup-1-ce7701c794586fb14192698e83d8e860.svg";